import type { ReactNode } from 'react'
import { cn } from '@/utils/cn'

export interface DescriptionItem {
  label: string
  value: ReactNode
  span?: 1 | 2
}

export function DescriptionList({ items, className }: { items: DescriptionItem[]; className?: string }) {
  return (
    <dl className={cn('grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-2', className)}>
      {items.map((item) => (
        <div key={item.label} className={cn('min-w-0', item.span === 2 && 'sm:col-span-2')}>
          <dt className="text-xs font-medium text-muted">{item.label}</dt>
          <dd className="mt-1 text-sm break-words text-ink">{item.value ?? '—'}</dd>
        </div>
      ))}
    </dl>
  )
}
